// Build-time settings (Vite env). Deployed builds use MSAL; the "test" auth mode exists
// only for Playwright builds and is refused on real hosts.
export interface SiteConfig {
  tenantId: string;
  clientId: string;
  apiBase: string;
  apiScope: string;
  authMode: 'msal' | 'test';
}

const env = import.meta.env as Record<string, string | undefined>;

export const config: SiteConfig = {
  tenantId: env.VITE_TENANT_ID ?? '',
  clientId: env.VITE_CLIENT_ID ?? '',
  apiBase: (env.VITE_API_BASE ?? '').replace(/\/$/, ''),
  apiScope: env.VITE_API_SCOPE ?? '',
  authMode: env.VITE_AUTH_MODE === 'test' ? 'test' : 'msal',
};

if (config.authMode === 'test' && !/^(localhost|127\.0\.0\.1)$/.test(location.hostname)) {
  throw new Error('Test sign-in is only allowed on localhost.');
}
